// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string(),
  name: __t.string(),
  logo: __t.string(),
  isGlaciEnabled: __t.option(__t.bool()).name("is_glaci_enabled"),
  runtimeUri: __t.option(__t.string()).name("runtime_uri"),
  runtimeModule: __t.option(__t.string()).name("runtime_module"),
  glaciFeatures: __t.option(__t.string()).name("glaci_features"),
  glaciBranding: __t.option(__t.string()).name("glaci_branding"),
  glaciInstances: __t.option(__t.string()).name("glaci_instances"),
  glaciContextCatalog: __t.option(__t.string()).name("glaci_context_catalog"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
});
